import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { SystemService } from 'common/services/core-services/system.service';
import { LoginDataService } from 'common/services/data-services/admin/login/login-form/login-data.services';
import { FormWidgetService } from 'common/widget/form-widget.service';
import { MetaModel } from 'common/models/utility-models/base-model';

import { LoginMetaModel } from 'common/models/page-models/Login/login/login-form-meta-model';
import { LoginModel } from 'common/models/page-models/Login/login/login-data-model';

@Injectable({
    providedIn: 'root'
})
export class LoginWidgetService extends FormWidgetService<LoginModel> {
    constructor(
        protected ds: LoginDataService,
        protected ss: SystemService,
        protected router: Router,
    ) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new LoginMetaModel();
        return meta.getMetaModel();
    }

}
